let fieldConfig = {
  version: 4.4,
  profileType: '19',
  queryForm: [
    {
      label: '纳税人识别号',
      selected: true,
      default: true,
      name: 'taxNo',
    },
    {
      label: '纳税人名称',
      selected: true,
      default: true,
      name: 'companyName',
    },
    {
      label: '退付手续费状态',
      selected: true,
      default: true,
      name: 'refundStatus',
      dict: 'gs_refundStatus',
      type: 'dict',
    },
    {
      label: '事业部',
      selected: false,
      default: false,
      name: 'departmentNo',
      dict: 'department_no',
      type: 'departmentNo',
    },
    {
      label: '所属区域',
      selected: false,
      default: false,
      name: 'regionName',
      type: 'regionNo',
    },
    {
      label: '管理城市',
      selected: false,
      default: false,
      name: 'cityName',
      type: 'managerCityNo',
    },
    {
      label: '主管税局省(市)',
      selected: false,
      default: false,
      name: 'province',
      type: 'taxBureauId',
    },
    {
      label: '跟进人',
      selected: false,
      default: false,
      name: 'province',
      type: 'follower',
    },
  ],
  table: [
    {
      label: '纳税人识别号',
      selected: true,
      default: true,
      name: 'taxNo',
      sort: false,
    },
    {
      label: '纳税人名称',
      selected: true,
      default: true,
      name: 'companyName',
      sort: false,
    },
    {
      label: '退付手续费状态',
      selected: true,
      default: true,
      name: 'refundStatus',
      dict: 'gs_refundStatus',
      type: 'dict',
      sort: false,
    },
    {
      label: '税款金额',
      selected: true,
      default: true,
      name: 'refundAmount',
      sort: false,
    },
    {
      label: '退付手续费金额',
      selected: true,
      default: true,
      name: 'refundHandlingAmount',
      sort: false,
    },
    {
      label: '事业部',
      selected: true,
      default: false,
      name: 'departmentNo',
      dict: 'department_no',
      type: 'dict',
      sort: false,
    },
    {
      label: '所属区域',
      selected: true,
      default: false,
      name: 'regionName',
      type: 'specialDict',
      specialDict: 'belleRegionList',
      sort: false,
    },
    {
      label: '管理城市',
      selected: true,
      default: false,
      name: 'cityName',
      sort: false,
    },
    {
      label: '主管税局所在省（市）',
      selected: true,
      default: false,
      name: 'province',
      sort: false,
    },
    {
      label: '异常信息提示',
      selected: true,
      default: true,
      name: 'informationTips',
      sort: false,
    },
    {
      label: '跟进人',
      selected: true,
      default: true,
      name: 'employeeName',
      type: 'follower',
      sort: false,
    },
  ],
}

export default fieldConfig



// WEBPACK FOOTER //
// ./src/app/declaration/personalIncomeTax/refundServiceChargeTaskTracking/fieldConfig.js